import { MARKET_FILTER_VALUES } from 'pages/Optimisation/constants';
import { IChartTrade } from 'types/trade';

const WholesaleMarkets = [
  'intraday',
  'dayAheadHalfHourly',
  'dayAheadHourly',
  'systemPrice',
  'ida1',
  'ida2',
  'otc',
  'longTermHedge',
] as const;
export type WholesaleMarket = (typeof WholesaleMarkets)[number];

const AncillaryMarkets = [
  'drLow',
  'drHigh',
  'dcLow',
  'dcHigh',
  'dmHigh',
  'dmLow',
  'positiveBr',
  'negativeBr',
  'positiveQr',
  'negativeQr',
  'positiveSr',
  'negativeSr',
  'positiveQrUtilisation',
  'negativeQrUtilisation',
  'positiveSrUtilisation',
  'negativeSrUtilisation',
] as const;
export type AncillaryMarket = (typeof AncillaryMarkets)[number];

const BalancingMechanismMarkets = [
  'balancingMechanismBid',
  'balancingMechanismOffer',
] as const;
export type BalancingMechanismMarket =
  (typeof BalancingMechanismMarkets)[number];

export type AllTradeMarkets =
  WholesaleMarket | AncillaryMarket | BalancingMechanismMarket;
export type TradeSide = 'buy' | 'sell';

export enum MarketKey {
  Ancillary = 'ancillary',
  Wholesale = 'wholesale',
  BalancingMechanism = 'balancingMechanism',
}

type TradeMarket =
  | {
      key: MarketKey.Ancillary;
      market: AncillaryMarket;
    }
  | {
      key: MarketKey.Wholesale;
      market: WholesaleMarket;
    }
  | { key: MarketKey; market?: string };

export type StackTrade = {
  id: number;
  tradeGroupSourceId: number;
  market: TradeMarket;
  start: Date;
  end: Date;
  value: number;
  price: number;
  offset: number;
  side?: TradeSide;
  base?: { start: Date; end: Date };
} & TradeMarket;

type LegendLabel = {
  label: string;
  exportLabel?: string;
  identifier: AllTradeMarkets | 'disabled';
  market: MarketKey | 'other';
  groupKey?: string;
};

export type LegendLabels = Record<MARKET_FILTER_VALUES, LegendLabel[]>;

export const ColorMapKeys = [
  'ancillary',
  'wholesale',
  'balancingMechanism',
  'other',
];

export type ColorMapKey = (typeof ColorMapKeys)[number];
export type ColorMap = Record<
  ColorMapKey,
  Partial<Record<AllTradeMarkets | 'disabled' | 'other', string>>
>;

export type IChangeOverType = 'BST' | 'GMT';
export type ContractedVolumeTooltipProps = {
  data: StackTrade;
  contractedPeriodTitle?: string;
  color?: string;
  isChangeOverDay?: boolean;
  changeOverType?: IChangeOverType;
};

export type ContractedVolumeData = {
  ancillary: IChartTrade[];
  wholesale: IChartTrade[];
  balancingMechanism: IChartTrade[];
};
